import React from 'react';
import Icon from '../../../components/AppIcon';


const AuthMethodSelector = ({ selectedMethod, onMethodChange, currentLanguage }) => {
  const authMethods = [
    {
      id: 'email',
      icon: 'Mail',
      label: currentLanguage === 'fr' ? 'Email' : 'Email',
      description: currentLanguage === 'fr' ? 'Connectez-vous avec votre email' : 'Sign in with your email'
    },
    {
      id: 'phone',
      icon: 'Phone',
      label: currentLanguage === 'fr' ? 'Téléphone' : 'Phone',
      description: currentLanguage === 'fr' ? 'Connectez-vous avec votre numéro' : 'Sign in with your phone number'
    },
    {
      id: 'whatsapp',
      icon: 'MessageCircle',
      label: 'WhatsApp OTP',
      description: currentLanguage === 'fr' ? 'Code OTP via WhatsApp' : 'OTP code via WhatsApp'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-foreground mb-4">
        {currentLanguage === 'fr' ? 'Méthode de connexion' : 'Login Method'}
      </h3>
      <div className="grid gap-3">
        {authMethods?.map((method) => (
          <button
            key={method?.id}
            onClick={() => onMethodChange(method?.id)}
            className={`
              w-full flex items-center p-4 rounded-lg border-2 transition-smooth text-left
              ${selectedMethod === method?.id 
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 hover:bg-muted/50'
              }
              ${method?.id === 'whatsapp' ? 'border-success hover:border-success' : ''}
            `}
          >
            <div className={`
              w-10 h-10 rounded-lg flex items-center justify-center mr-3
              ${method?.id === 'whatsapp' ?'bg-success text-success-foreground' 
                : selectedMethod === method?.id 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-muted text-muted-foreground'
              }
            `}>
              <Icon name={method?.icon} size={20} />
            </div>
            
            <div className="flex-1">
              <div className="font-medium text-foreground">{method?.label}</div>
              <div className="text-sm text-muted-foreground">{method?.description}</div>
            </div>
            
            <div className={`
              w-5 h-5 rounded-full border-2 flex items-center justify-center
              ${selectedMethod === method?.id 
                ? method?.id === 'whatsapp' ?'border-success bg-success' :'border-primary bg-primary' :'border-muted-foreground'
              }
            `}>
              {selectedMethod === method?.id && (
                <Icon name="Check" size={12} className="text-white" />
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AuthMethodSelector;